import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App.jsx";
import { Provider } from "react-redux";
import configureStore from "./redux/store";
import * as serviceWorker from "./serviceWorker";
import ReactGA from "react-ga";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

ReactGA.initialize("G-HJTR7B1FKL");
ReactGA.pageview(window.location.pathname + window.location.search);

export const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={configureStore()}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
